import { extendTheme } from '@chakra-ui/react';
const theme = extendTheme({
    colors: {
      brand: {
        50: '#f5e8e8',
        100: '#ecd0d0',
        200: '#e1b7b7',
        300: '#d69d9d',
        400: '#cc8484',
        500: '#b36666',
        600: '#8c4d4d',
        700: '#663434',
        800: '#401b1b',
        900: '#1a0000',
      },
    },
  });
export default theme;